export enum PhysicalInventoryCountEnums {
  count1 = 1,
  count2 = 2,
  count3 = 3
}
